import { Component, ViewChild } from '@angular/core';
import { I18NService } from '../../../shared/i18n/i18n.service';
import { IPlaceValuelistService } from '../../../iPlace/iPlace-valuelist.service';
import { BsDatepickerConfig } from 'ngx-bootstrap';
import { TankBooksService } from './tank-books.service';
import { TankBook } from './tank-book';
import { TankService } from '../Tank.service';
import { ItemTagType } from '../../tag/Tag';
import { Globals } from '../../../globals';
import { TagService } from '../../tag/Tag.service';
import { AuthService } from '../../../shared/auth/auth.service';
import * as XLSX from 'xlsx';
import { WorkBook } from 'xlsx';

@Component({
  selector: 'app-tank-books',
  templateUrl: './tank-books.component.html',
  styleUrls: ['./tank-books.component.css']
})
export class TankBooksComponent {

  tankBook: TankBook[] = [];
  dataDownload: TankBook[] = [];
  isLoading = false;
  dropdownList: any = [];
  iPlaceList: any[] = [];
  iPlaceMap: any[];
  dropdownListTanks: any = [];
  selectedItems: any;
  selectedTanks: any = [];
  items: any[] = [];
  itemTags: any[] = [];
  tanks: any[] = [];
  dropdownSettings: any = {};
  dropdownTanksSettings: any = {};
  dateRangeFilter: any;
  bsConfig: Partial<BsDatepickerConfig>;
  tableMessages: any;
  rows: any = [];
  selected: boolean = false;
  groupBy: boolean = true;
  tankMessage: string;
  messageGroup: string;
  messageUngroup: string;

  @ViewChild('multiSelect', { static: true }) element;

  constructor(
    private i18nService: I18NService,
    private iPlaceValuelistService: IPlaceValuelistService,
    private tankBooksService: TankBooksService,
    private tankService: TankService,
    private authService: AuthService,
    private tagService: TagService,
    private globals: Globals
  ) {

    this.bsConfig = Object.assign({}, {containerClass: "theme-custom", showWeekNumbers: false});
    let startDate = new Date();
    startDate.setHours(0,0,0,0);
    startDate = new Date(startDate.getTime() - 86400000);
    let endDate = new Date();
    endDate.setHours(0,0,0,0);
    endDate = new Date(endDate.getTime() - (28 * 86400000));
    this.dateRangeFilter = [endDate, startDate];

    if ( (<any> Object).values(this.iPlaceValuelistService.getValuelist()).length ) {
      this.iPlaceList = (<any>  Object).values(this.iPlaceValuelistService.getValuelist())
        .sort((a: any, b: any) => a.iPlaceName.localeCompare(b.iPlaceName));
      this.iPlaceMap = this.iPlaceList.reduce((previous: any, current: any) => {
        previous[current.id] = current;
        return previous;
      }, {});
      this.getStoreTankBook();
    } else {
      this.iPlaceValuelistService.reload()
        .then( () => {
          this.iPlaceList = (<any> Object).values(this.iPlaceValuelistService.getValuelist())
            .sort((a:any, b:any) => a.iPlaceName.localeCompare(b.iPlaceName));
          this.iPlaceMap = this.iPlaceList.reduce((previous: any, current: any) => {
            previous[current.id] = current;
            return previous;
          }, {});
          if ( globals.tenant == "ecomanager" ) {
            this.setGroupedIPlaceList();
          } else {
            this.dropdownList = this.iPlaceList;
          }
          this.getStoreTankBook();
        });
    }

    let groupBy = null;

    if ( globals.tenant == "ecomanager" ) {
      groupBy = "tag";
      this.tagService.getItemTags(ItemTagType.IPLACE)
        .then( itemTags => {
          this.itemTags = itemTags;
          this.setGroupedIPlaceList();
        });
    } else {
      this.dropdownList = this.iPlaceList;
    }

    this.isLoading = false;

    this.dropdownSettings = {
      singleSelection: true,
      enableCheckAll: false,
      enableFilterSelectAll: false,
      primaryKey: 'idiPlace',
      labelKey: 'iPlaceName',
      selectAllText: i18nService.get("selectAll"),
      unSelectAllText: i18nService.get("unselectAll"),
      filterSelectAllText: i18nService.get("selectAllFiltered"),
      filterUnSelectAllText: i18nService.get("unselectAllFiltered"),
      noDataLabel: i18nService.get("noResults"),
      text: i18nService.get("selectStation"),
      searchPlaceholderText: i18nService.get("search"),
      badgeShowLimit: 2,
      enableSearchFilter: true,
      groupBy: groupBy,
      classes: "form-angular2-multiselect"
    };

    this.dropdownTanksSettings = {
      singleSelection: true,
      enableCheckAll: false,
      primaryKey: 'tankId',
      labelKey: 'name',
      selectAllText: i18nService.get("selectAll"),
      unSelectAllText: i18nService.get("unselectAll"),
      filterSelectAllText: i18nService.get("selectAllFiltered"),
      filterUnSelectAllText: i18nService.get("unselectAllFiltered"),
      noDataLabel: i18nService.get("noResults"),
      text: i18nService.get("selectTank"),
      searchPlaceholderText: i18nService.get("search"),
      enableSearchFilter: true,
      classes: "form-angular2-multiselect tank-select"
    };

    this.tableMessages = {};
    this.tableMessages.emptyMessage = this.i18nService.get("noDataToDisplay");
    this.tankMessage = this.i18nService.get("tank");
    this.messageGroup = this.i18nService.get("groupSiphonedTanks");
    this.messageUngroup = this.i18nService.get("unGroupSiphonedTanks");

    this.restartSummaryRows();
  }

  onItemSelect(item: any) {
    this.reloadTanks();
  }

  onItemDeSelect(item: any) {
    this.clearFilters();
  }

  onDateRangeChange(any: any) {
    if(this.selectedTanks.length > 0) {
      this.reloadItems();
    }
  }

  onTankSelect(item: any) {
    this.reloadItems();
  }

  onTankDeselect(item: any) {
    this.tanks = [];
  }

  clearFilters() {
    this.tankBook = [];
    this.items = [];
    this.tanks = [];
    this.selectedItems = null;
    this.selectedTanks = [];
    this.dropdownListTanks = [];
    this.selected = false;
    this.setStoreTankBook();
    this.restartSummaryRows();
  }

  private getStoreTankBook()  {
    let data = localStorage.getItem("tank_book_"+ this.authService.getUserID());
    if( data ) {
      if( JSON.parse(data)[0] && JSON.parse(data)[0].length > 0 ) {
        this.items = JSON.parse(data)[0]
          .filter(item => this.iPlaceList.findIndex(iPlace => iPlace.idiPlace == item.idiPlace) != -1);
        this.selectedItems = this.items.map(item => this.iPlaceMap[item.id]);
        this.getTanksByiPlace();
      }
      if( JSON.parse(data)[1] && JSON.parse(data)[1] != null ) {
        this.selectedTanks.push(JSON.parse(data)[1] as any[]);
        this.tanks = this.tanks.filter(item => this.selectedTanks.findIndex(selected => selected.tankId == item.tankId) != -1);
        let newItems = this.selectedTanks.filter(selected => this.tanks.findIndex(item => selected.tankId == item.tankId) == -1);
        this.tanks.push(...newItems);
        this.getTankSeries();
      }
      if( typeof JSON.parse(data)[2] != 'undefined' )
        this.groupBy = JSON.parse(data)[2];
    }
  }

  private setStoreTankBook() {
    localStorage.setItem("tank_book_" + this.authService.getUserID(), JSON.stringify([this.items, this.selectedTanks[0], this.groupBy]));
  }

  reloadTanks() {
    this.items = this.items.filter(item => this.selectedItems.findIndex(selected => selected.idiPlace == item.idiPlace) != -1);
    let newItems = this.selectedItems.filter(selected => this.items.findIndex(item => selected.idiPlace == item.idiPlace) == -1);
    this.items.push(...newItems);

    this.getTanksByiPlace();
  }

  private reloadItems() {
    this.getTankSeries();
  }

  private getTanksByiPlace() {
    let iPlaceIds = this.selectedItems[0].idiPlace;
    this.selectedTanks = [];
    this.dropdownListTanks = [];
    this.selected = false;

    if(iPlaceIds != null) {
      this.tankService.getTanks(iPlaceIds).then(response => {
        this.tanks = response
          .sort((a, b) => a.localTankId < b.localTankId ? -1 : a.localTankId > b.localTankId ? 1 : 0)
          .filter(tank => tank.productId != null);
        this.groupBySiphonedTanks();
      });
    } else {
      this.dropdownListTanks = [];
    }
  }

  private getTankSeries() {
    this.isLoading = true;

    if(this.tanks.length > 0) {
      let startDate = this.dateRangeFilter[0].getTime();
      let endDate = this.dateRangeFilter[1].getTime();
      this.tankBooksService.get(this.selectedTanks[0].tankId, this.groupBy, startDate, endDate).then(response => {
        this.isLoading = false;
        this.tankBook = response;
        this.setStoreTankBook();
        this.selected = true;
        this.summaryFunction();
        this.dataDownload = response;
      }).catch(error => {
        this.isLoading = false;
      });
    } else {
      this.setStoreTankBook();
      this.tankBook = [];
      this.isLoading = false;
    }
  }

  private restartSummaryRows() {
    this.rows = [{
      "function": this.i18nService.get('total'),
      'deliveryTank': 0,
      'closingLevel': 0,
      'salesTank': 0,
      'tankSettings': 0,
      'salesPos': 0,
      'difference': 0,
      'accumulatedDifferencePercentaje': ''
    },{
      "function": this.i18nService.get('average'),
      'deliveryTank': 0,
      'closingLevel': 0,
      'salesTank': 0,
      'tankSettings': 0,
      'salesPos': 0,
      'difference': 0,
      'accumulatedDifferencePercentaje': 0
    }];
  }

  summaryFunction() {
    let n = this.tankBook.length;
    let accumulateDifferencePercentaje = 0;

    this.restartSummaryRows();
    this.tankBook.forEach(tank => {
      this.rows[0].deliveryTank += tank.deliveryTank;
      this.rows[0].closingLevel += tank.closingLevel;
      this.rows[0].salesTank += tank.salesTank;
      this.rows[0].salesPos += tank.salesPos;
      this.rows[0].difference += tank.difference;
      accumulateDifferencePercentaje += tank.accumulatedDifferencePercentaje;
    });

    if(n > 0) {
      this.rows[1].deliveryTank = this.calculateAverage(this.rows[0].deliveryTank, n);
      this.rows[1].closingLevel = this.calculateAverage(this.rows[0].closingLevel, n);
      this.rows[1].salesTank = this.calculateAverage(this.rows[0].salesTank, n);
      this.rows[1].salesPos = this.calculateAverage(this.rows[0].salesPos, n);
      this.rows[1].difference = this.calculateAverage(this.rows[0].difference, n);
      this.rows[1].accumulatedDifferencePercentaje = this.calculateAverage(accumulateDifferencePercentaje, n);
    }
  }

  private calculateAverage(x: number, n: number): number {
    return x / n;
  }

  getCellClass(row: any): any{
    return {
      'ngx-datatable-value-negative': row.value < 0
    };
  }

  private setGroupedIPlaceList() {
    if ( this.iPlaceMap ) {
      this.itemTags.forEach(itemTag => {
        let iplace = this.iPlaceMap[itemTag.id.itemId];
        if ( iplace && !iplace.tag ) {
          iplace.tag = itemTag.id.tagKey;
        }
      });
    }

    if ( this.iPlaceList.length ) {
      if ( !this.itemTags || !this.itemTags.length ) {
        this.element.settings.groupBy = false;
      }
    }

    this.dropdownList = this.iPlaceList.sort((a:any, b:any) => {
      if ( !a.tag ) {
        return -1
      } else if (a.tag == b.tag) {
        return a.iPlaceName.localeCompare(b.iPlaceName);
      } else {
        return a.tag.localeCompare(b.tag);
      }
    });
  }

  onClickGroupByFilter(): void {
    this.groupBy = !this.groupBy;
    this.selectedTanks = [];
    this.dropdownListTanks = [];
    this.tankBook = [];
    this.selected = false;
    this.groupBySiphonedTanks();
  }

  groupBySiphonedTanks() {
    if ( this.groupBy ) {
      let siphonedTanks = [], parentTanks = [];
      let mapTanks = new Map();

      this.tanks
        .forEach(tank => {
          if( tank.siphonedTankId != null && !siphonedTanks.find(item => tank.siphonedTankId == item) )
            siphonedTanks.push(tank);
          else if ( tank.siphonedTankId == null || siphonedTanks.find(siphonedTank => siphonedTank.siphonedTankId == tank.tankId) )
            parentTanks.push(tank);
      });

      mapTanks = parentTanks.reduce(function(map, tank) {
        if ( tank.siphonedTankId == null && siphonedTanks.filter(siphonedTank => siphonedTank.siphonedTankId == tank.tankId).length > 0) {
          map[tank.tankId] =  map[tank.tankId] || [];
          map[tank.tankId] = siphonedTanks.filter(siphonedTank => siphonedTank.siphonedTankId == tank.tankId);
        }
        return map;
      }, {});

      parentTanks.forEach(tank => {
        if( mapTanks[tank.tankId] ) {
          tank.name = this.tankMessage + " " + tank.localTankId;
          mapTanks[tank.tankId].forEach(siphonedTank => {
            tank.name += ", " + siphonedTank.localTankId;
          });
          tank.name += " - " + this.i18nService.get(tank.productId);
        } else {
          tank.name = this.tankMessage + " " + tank.localTankId + " - " + this.i18nService.get(tank.productId);
        }
      });
      this.dropdownListTanks = parentTanks;
    } else {
      this.tanks
        .forEach(tank => {
          tank.name = this.tankMessage + " " + tank.localTankId + " - " + this.i18nService.get(tank.productId);
        });
      this.dropdownListTanks = this.tanks;
    }
  }

  private getDataExport(): WorkBook {
    this.dataDownload.forEach(data => {
      delete data.tankId;
    });

    let index = this.dataDownload.length + 2;
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([], {header: [this.i18nService.get('date'), this.i18nService.get('openingLevel'), this.i18nService.get('deliveryTank'),
        this.i18nService.get('closingLevel'), this.i18nService.get('salesTank'),this.i18nService.get('settingTank'),
        this.i18nService.get('salesPos'), this.i18nService.get('difference'),
        this.i18nService.get('accumulatedDifference'), this.i18nService.get('accumulatedDifferencePercentaje')],cellDates: true});

    XLSX.utils.sheet_add_json(ws, this.dataDownload, {skipHeader: true, cellDates: true, origin: 1});

    XLSX.utils.sheet_add_json(ws, [{date: '',openingLevel: this.rows[0].function, deliveryTank: this.rows[0].deliveryTank,
      closingLevel: this.rows[0].closingLevel, salesTank: this.rows[0].salesTank, settingTank: 0,
      salesPos: this.rows[0].salesPos, difference: this.rows[0].difference,
      accumulatedDifference: '', accumulatedDifferencePercentaje: ''},
      {date: '',openingLevel: this.rows[1].function, deliveryTank: this.rows[1].deliveryTank,
        closingLevel: this.rows[1].closingLevel, salesTank: this.rows[1].salesTank, settingTank: 0,
        salesPos: this.rows[1].salesPos, difference: this.rows[1].difference,
        accumulatedDifference: '', accumulatedDifferencePercentaje: this.rows[1].accumulatedDifferencePercentaje}], {skipHeader:true, origin: 'A' + index});
    let range = XLSX.utils.decode_range(ws['!ref']);
    for (let r = range.s.r; r <= range.e.r; r++){
      for (let c = range.s.c; c <= range.e.c; c++){
        let cell = ws[XLSX.utils.encode_cell({r: r, c: c})];
        let format = '0.00';
        if( c == 1 || c == 2 || c == 3 || c == 5 ) format = '0';
        if( cell || cell.t == 'n' ) cell.z = format;
      }
    }

    for(let i = 1; i <= this.dataDownload.length; i++){
      let cell = ws[XLSX.utils.encode_cell({r: i, c: 0})];
      cell.t = 'd';
      cell.z = 'dd/mm/yyyy';
      cell.w = new Date(cell.v).toLocaleDateString().toString();
      XLSX.utils.format_cell(cell, cell.w, {dateNF:'dd/mm/yyyy'});
    }
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, this.i18nService.get("tankBook"));
    return wb;
  }

  public exportXLS() {
    if(this.selectedTanks.length > 0)
       XLSX.writeFile(this.getDataExport(), this.selectedTanks[0].name + " - " + new Date().toLocaleString() + ".xlsx",{ bookType: 'xlsx', type: 'buffer' });
  }

  public exportCSV() {
    if(this.selectedTanks.length > 0)
      XLSX.writeFile(this.getDataExport(), this.selectedTanks[0].name + " - " + new Date().toLocaleString() + ".csv", { bookType: 'csv', type: 'buffer' })
   }

}
